// src/components/shared/LoadingScreen/LoadingScreen.js
import React from 'react';
import './LoadingScreen.css';

const LoadingScreen = () => (
  <div className="loading-screen">
    <div className="loader"></div>
  </div>
);

export default LoadingScreen;